import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { blogApi } from "./adminApi";
import "./Admin.css";
export default function ManageBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState(null);
  async function load() {
    setLoading(true);
    setError("");
    try {
      const data = await blogApi.listAll();
      setBlogs(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    load();
  }, []);
  async function handleDelete(post) {
    if (!window.confirm(`Delete the post "${post.title}"? This can't be undone.`)) return;
    setDeletingId(post._id);
    try {
      await blogApi.remove(post._id);
      setBlogs((prev) => prev.filter((b) => b._id !== post._id));
    } catch (err) {
      alert(err.message);
    } finally {
      setDeletingId(null);
    }
  }
  return (
    <div>
      <div className="admin-topbar">
        <h1>Blog Posts</h1>
        <Link to="/admin/blogs/new" className="admin-btn admin-btn--primary" style={{ width: "auto" }}>
          <Plus size={16} /> New Post
        </Link>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {loading ? (
        <p>Loading…</p>
      ) : blogs.length === 0 ? (
        <div className="admin-table-wrap">
          <div className="admin-empty">No blog posts yet. Click "New Post" to write your first one.</div>
        </div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Slug</th>
                <th>Category</th>
                <th>Status</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((post) => (
                <tr key={post._id}>
                  <td>{post.title}</td>
                  <td style={{ color: "var(--c-mut)" }}>{post.slug}</td>
                  <td>{post.category || "—"}</td>
                  <td>
                    <span className={`admin-badge admin-badge--${post.status === "published" ? "published" : "draft"}`}>
                      {post.status === "published" ? "Published" : "Draft"}
                    </span>
                  </td>
                  <td>{new Date(post.updatedAt).toLocaleDateString()}</td>
                  <td>
                    <div className="admin-table__actions">
                      <Link to={`/admin/blogs/${post._id}/edit`} className="admin-btn admin-btn--outline admin-btn--sm">
                        <Pencil size={14} /> Edit
                      </Link>
                      <button
                        className="admin-btn admin-btn--danger admin-btn--sm"
                        onClick={() => handleDelete(post)}
                        disabled={deletingId === post._id}
                      >
                        <Trash2 size={14} /> {deletingId === post._id ? "Deleting…" : "Delete"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}